import React, { useCallback } from 'react';
import { Button, Nav, Navbar } from 'reactstrap';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { Music24FullLogo } from '../../music24/components/Music24FullLogo';
import { AccountSelectorButton } from '../accountSelectorButton/AcccountSelectorButton';
import { useShouldShowNavbar } from './hooks/useShouldShowNavbar';
import { SmartLinksNavbarMenu } from './SmartLinksNavbarMenu';
import { SMLLink } from '../../music24/components/SMLLink/SMLLink';
import { SMLRoutes, SMLRouteNames } from '../../../routing/sml/SMLRoutes';
import { useUserToken } from '../../../redux/slices/appInfo/hooks';
import { useSMLRouter } from '../../../routing/sml/hooks';

export const SmartLinksNavbarComponent: React.FC = React.memo(() => {
  const shouldShowNavbar = useShouldShowNavbar();
  const intl = useIntl();
  const userToken = useUserToken();
  const router = useSMLRouter();
  const handleSignUp = useCallback(() => {
    router.push(SMLRoutes.auth);
  }, [router]);

  if (!shouldShowNavbar) {
    return null;
  }

  const isAuthenticated = userToken !== null && userToken !== undefined;

  return (
    // When authenticated, the sidebar owns the brand + account on desktop, and
    // on mobile a page inside `SMLContainer` draws its own top bar (`MobileNav`),
    // which hides this one. It stays, with its "…" menu, for signed-in pages
    // outside the container (the SmartLink editors). Anonymous/public mode keeps the bar on all sizes
    // for the "Start a 7-day trial" CTA.
    <Navbar
      expand="md"
      className={clsx('sml-navbar', isAuthenticated && 'd-md-none sml-navbar-signed-in')}
      sticky="top"
    >
      <SMLLink to={[SMLRouteNames.home]} className="cursor-pointer ms-2 navbar-brand">
        <Music24FullLogo size={20} />
      </SMLLink>
      <Nav className="ms-auto">
        {isAuthenticated ? (
          <>
            <AccountSelectorButton />
            <SmartLinksNavbarMenu />
          </>
        ) : (
          <Button color="primary" size="sm" className="me-2" onClick={handleSignUp}>
            {intl.formatMessage({
              id: 'app.sml.publicMode.banner.cta.paidOnly',
              defaultMessage: 'Start a 7-day trial',
            })}
          </Button>
        )}
      </Nav>
    </Navbar>
  );
});

export const SmartLinksNavbar = TypedMemo(SmartLinksNavbarComponent);
